import React from 'react';
import { Text } from 'react-native';
import { colors } from '../constants';
export const ActionBig = _ref => {
  let {
    textStyle,
    children,
    textColor = colors.neutral900
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 16
      }
    }, textStyle]
  }, children);
};
export const ActionSmall = _ref2 => {
  let {
    textStyle,
    children,
    textColor = colors.neutral900
  } = _ref2;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 14
      }
    }, textStyle]
  }, children);
};
export const BodyBig = _ref3 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref3;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 16
      }
    }, textStyle]
  }, children);
};
export const BodySmall = _ref4 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref4;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 16
      }
    }, textStyle]
  }, children);
};
export const Description = _ref5 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref5;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 12
      }
    }, textStyle]
  }, children);
};
export const DescriptionBold = _ref6 => {
  let {
    textStyle,
    children,
    textColor = colors.neutral900
  } = _ref6;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 14
      }
    }, textStyle]
  }, children);
};
export const H1 = _ref7 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref7;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 24,
        fontWeight: '600'
      }
    }, textStyle]
  }, children);
};
export const H2 = _ref8 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref8;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 24
      }
    }, textStyle]
  }, children);
};
export const H3 = _ref9 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref9;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 20
      }
    }, textStyle]
  }, children);
};
export const H4 = _ref10 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref10;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 18
      }
    }, textStyle]
  }, children);
};
export const H5 = _ref11 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref11;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 16
      }
    }, textStyle]
  }, children);
};
export const H6 = _ref12 => {
  let {
    textStyle,
    children,
    textColor = colors.mint900
  } = _ref12;
  return /*#__PURE__*/React.createElement(Text, {
    style: [{
      color: textColor,
      ...{
        fontSize: 18
      }
    }, textStyle]
  }, children);
};
export const Typography = {
  ActionBig,
  ActionSmall,
  BodyBig,
  BodySmall,
  Description,
  DescriptionBold: DescriptionBold,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6
};
//# sourceMappingURL=Typography.js.map